import { Component, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatSelectModule } from '@angular/material/select';

export interface PortionDialogData {
  categories: { uuid: string; name: string }[];
}

@Component({
  selector: 'app-portion-dialog',
  standalone: true,
  imports: [CommonModule, FormsModule, MatDialogModule, MatFormFieldModule, MatInputModule, MatButtonModule, MatSelectModule],
  template: `
    <h2 mat-dialog-title>Nueva porción</h2>
    <div mat-dialog-content class="space-y-3">
      <mat-form-field appearance="fill" class="w-100">
        <mat-label>Nombre</mat-label>
        <input matInput [(ngModel)]="name" />
      </mat-form-field>
      <mat-form-field appearance="fill" class="w-100">
        <mat-label>Categorías</mat-label>
        <mat-select [(ngModel)]="categoryUuids" multiple>
          <mat-option *ngFor="let c of data.categories" [value]="c.uuid">{{ c.name }}</mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <div mat-dialog-actions align="end">
      <button mat-stroked-button (click)="dialogRef.close(null)">Cancelar</button>
      <button mat-flat-button color="primary" (click)="save()" [disabled]="!name || !name.trim()">Guardar</button>
    </div>
  `,
  styles: [`
    /* Remove vertical divider/outline pieces from MDC form-field */
    :host ::ng-deep .mat-mdc-form-field .mdc-notched-outline,
    :host ::ng-deep .mat-mdc-form-field .mdc-notched-outline__leading,
    :host ::ng-deep .mat-mdc-form-field .mdc-notched-outline__notch,
    :host ::ng-deep .mat-mdc-form-field .mdc-notched-outline__trailing,
    :host ::ng-deep .mat-mdc-form-field .mat-mdc-form-field-outline,
    :host ::ng-deep .mat-mdc-form-field .mat-mdc-form-field-outline-gap,
    :host ::ng-deep .mat-mdc-form-field .mat-mdc-form-field-outline-start,
    :host ::ng-deep .mat-mdc-form-field .mat-mdc-form-field-outline-end,
    :host ::ng-deep .mat-mdc-form-field .mat-mdc-form-field-focus-overlay {
      display: none !important;
      border: 0 !important;
    }
  `]
})
export class PortionDialogComponent {
  name = '';
  categoryUuids: string[] = [];

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: PortionDialogData,
    public dialogRef: MatDialogRef<PortionDialogComponent>
  ) {}

  save() {
    this.dialogRef.close({ name: this.name.trim(), categoryUuids: this.categoryUuids });
  }
}
